import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { LabelControl } from '../../../form-models/form-control-base';

@Component({
  selector: 'hb-dynamic-label',
  templateUrl: './dynamic-label.component.html',
})
export class DynamicLabelComponent {
  @Input() control: LabelControl;
  @Input() formGroup: FormGroup;

  constructor() {}
}
